import { createAppSlice } from '../../redux';

const initialState = {
  isLoading: false,
  isTraced: false,
};
export const tracerSlice = createAppSlice({
  name: 'tracerSlice',
  initialState,
  reducers: {
    tracerRequest: (state) => {
      state.isLoading = true;
      state.isTraced = false;
    },
    tracerSuccess: (state) => {
      state.isLoading = false;
      state.isTraced = true;
    },
    tracerFailure: (state) => {
      state.isLoading = false;
      state.isTraced = false;
    },
  },
});
